class AddBreakTooltip {
  constructor() {
    this.config = {
      moduleList: () => document.querySelectorAll('[data-module="AddBreakTooltip"]')
    };
  }

  init() {
    const { moduleList } = this.config;

    moduleList().forEach(_module => {
      const module = _module;
      const { initialized, tooltip } = module.dataset;

      if (initialized) return;

      module.dataset.initialized = true;

      const text = tooltip.split('{BREAK}');
      let newText = text[0];

      for (let i = 1; i < text.length; i += 1) {
        newText += `\n ${text[i]}`;
      }

      module.setAttribute('data-tooltip', newText);
    });
  }
}

export default AddBreakTooltip;
